import Basics from './basics'

export default Basics
